function loadInstitusi(view) {
    return () => import( /* webpackChunkName: "kampusMengajar-[request]" */ `../../views/KampusMerdeka/Institusi/${view}.vue`)
}

const routeInstitusi = [
    {
        path: '/institution/desa',
        name: 'DataDesa',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadInstitusi('ListDataDesa')
    },
    {
        path: '/institution/sekolah',
        name: 'DataSekolah',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadInstitusi('ListDataSekolah')
    },
    {
        path: '/desa',
        name: 'DataDesaMahasiswa',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadInstitusi('ListDataDesaMahasiswa')
    },
    {
        path: '/sekolah',
        name: 'DataSekolahMahasiswa',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadInstitusi('ListDataSekolahMahasiswa')
    },
]

export default routeInstitusi